// useBeneficiary — TanStack Query hook for the per-beneficiary detail
// page. Returns the bene row + its full payout history in one
// round-trip via GET /v1/merchants/:id/beneficiaries/:bid.
//
// queryKey is scoped per-merchant + per-bene so cache splits cleanly
// when an admin switches between merchants or operators navigate
// between beneficiaries. 30s refetch keeps a long-open detail page
// warm without hammering — payouts only land at provider response
// time, which is a slow channel relative to UI polling.
import { useQuery } from "@tanstack/react-query";

import { getBeneficiary } from "@/api/beneficiaries";
import { useAuth } from "@/store/auth";
import { useUI } from "@/store/ui";

export function useBeneficiary(beneficiaryId: number | null) {
  const status = useAuth((s) => s.status);
  const currentMerchantId = useUI((s) => s.currentMerchantId);

  return useQuery({
    queryKey: ["beneficiary", currentMerchantId, beneficiaryId],
    queryFn: () => getBeneficiary(currentMerchantId!, beneficiaryId!),
    enabled:
      status === "authenticated" &&
      currentMerchantId != null &&
      beneficiaryId != null &&
      beneficiaryId > 0,
    staleTime: 30_000,
    refetchInterval: 30_000,
  });
}
